module.exports = __webpack_public_path__ + "static/media/snow1.556a6862.webm";